export default {
  name: "App",
  mounted() {
    const meta = document.createElement("meta");
    meta.setAttribute("name", "viewport");
    meta.setAttribute("content", "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no");
    document.getElementsByTagName("head")[0].appendChild(meta);
  }
};